export * from './Login';
export * from './Dashboard';
export * from './Product';
export * from './Orders';
export * from './Configuration';
